<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!vehicle">
      <span class="loader"></span>
    </span>
    <vehicle-form
      v-if="vehicle"
      :loading="loading"
      :vehicleData="vehicle"
      :formErrors="formErrors"
      :showCustomer="true"
      :showMecanic="true"
      @vehicleSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import VehicleForm from "../partials/VehicleForm.vue";
import requestErrorMixin from "@/mixins/request-error-mixin";

export default {
  layout: "DashboardLayout",

  components: { VehicleForm },

  mixins: [alertLeave, requestErrorMixin],

  props: {
    vehicleId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      vehicle: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("vehicles/get", this.vehicleId);
        this.vehicle = this.$store.getters["vehicles/vehicle"];
        this.loading = false;
      } catch (error) {
        this.showRequestError(
          error,
          true,
          this.$t("VEHICLES.FORBIDDEN_ERRORS.VIEW")
        );
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(vehicle) {
      this.loading = true;
      const vehicleData = cloneDeep(vehicle);

      try {
        await this.$store.dispatch("vehicles/update", vehicleData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("VEHICLES.VEHICLE_UPDATED"),
        });
        const vehicle = this.$store.getters["vehicles/vehicle"];
        this.$emit("onViewVehicle", vehicle, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
